import BaseComponent from '../base.js';
import tag from '../utilComponents.js';

import * as styles from './switcher.module.scss';

/** @type {BaseComponent<HTMLInputElement>} */
export default class Switcher extends BaseComponent {
  /**
   * @type {StateObj['difficulty']}
   * @private
   */
  difficulty;

  /**
   * @type {HTMLInputElement}
   * @private
   */
  input;

  /** @param {StateObj['difficulty']} difficulty */
  constructor(difficulty) {
    super({
      elementTag: 'label',
      classes: [styles.switcher],
      text: difficulty,
    });

    this.difficulty = difficulty;
    this.appendSingle(this.createInput());
    this.setListeners();
  }

  /**
   * Sets event listeners.
   * @returns {void}
   * @private
   */
  setListeners() {
    window.addEventListener('changestart', this.handleStart.bind(this));
    this.addListener('change', this.handleInputChange.bind(this));
    window.addEventListener(
      'changedifficulty',
      this.handleChangeDifficulty.bind(this)
    );
  }

  /**
   * Creates input component.
   * @returns {BaseComponent}
   */
  createInput() {
    const isEasy = this.difficulty === 'easy';

    const input = tag.input({
      name: 'difficulty',
      value: this.difficulty,
      type: 'radio',
      classes: [styles.switcherInput],
      checked: isEasy,
    });

    if (isEasy) this.addClasses(styles.active);

    this.input = input.getElement();

    return input;
  }

  /**
   * Handles difficulty levels.
   * @param {InputEvent} e
   * @returns {void}
   * @private
   */
  handleInputChange(e) {
    if (this.state.start) return;

    if (e.target && e.target instanceof HTMLInputElement) {
      const difficulty = /** @type {StateObj['difficulty']} */ (e.target.value);
      this.state.difficulty = difficulty;
    }
  }

  /**
   * Handles the state's difficulty property changes.
   * @param {CustomEvent<Partial<StateObj>>} e
   * @returns {void}
   * @private
   */
  handleChangeDifficulty(e) {
    const { difficulty } = e.detail;
    if (this.difficulty === difficulty) {
      this.addClasses(styles.active);
    } else {
      this.removeClasses(styles.active);
    }
    // TODO change styles based on active input
  }

  /**
   * Handles the state's start property changes.
   * @param {CustomEvent<Partial<StateObj>>} e
   * @returns {void}
   * @private
   */
  handleStart(e) {
    const { start } = e.detail;
    if (start) this.input.disabled = true;
    else this.input.disabled = false;
  }
}
